import { Unit } from "@/@types";
import { ConnectorEntity, PlanEntity } from "@/domain/entities";
import { formatCurrency } from "@/utils/Helper";
import { Connector } from "./Connector";
import { Partnership } from "./Partnership";

export class Plan {
  id?: string;
  title: string;
  unit: string;
  value: string;
  idle_grace_period: string;
  idle_value: string;
  connectors?: Connector[];
  partnership?: Partnership;
  partnership_id: string;
  entity?: PlanEntity;

  constructor(plan: PlanEntity) {
    const unit = unitLabels[plan.unit];

    this.id = plan.id;
    this.title = plan.title;
    this.unit = `Por ${unit}`;
    this.value = `${formatCurrency(plan.value)} ${unit}`;
    this.idle_grace_period = `${plan.idle_grace_period} min`;
    this.idle_value = formatCurrency(plan.idle_value);
    this.entity = plan;

    if (plan.connectors) {
      this.connectors = plan.connectors.map((elem) => new Connector(elem));
    }
    this.partnership_id = plan.partnership_id || ''
    if (plan.partnership) {
      this.partnership = new Partnership(plan.partnership)
    }
  }

  static empty: Plan = {
    title: "",
    unit: "",
    value: "",
    idle_grace_period: "",
    idle_value: "",
    partnership_id: "",
  };
}

const unitLabels: Record<Unit, string> = {
  kwh: "kWh",
  hour: "hora",
};
